import { CardContent, Card, CardTitle, CardHeader } from '@client/toolkit';

export const CardWrapper = ({ title, children }: { title: string; children: React.ReactNode }) => {
  return (
    <Card className="h-fit">
      <CardHeader>
        <CardTitle variant="default" className="flex items-center gap-2 justify-between p-2">
          <div className="flex items-center text-lg gap-2">{title}</div>
        </CardTitle>
      </CardHeader>
      <CardContent className="gap-4">{children}</CardContent>
    </Card>
  );
};
